module.exports = __webpack_public_path__ + "static/media/landing-person-2.af2c17b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing-person-2.png
// module id = 1141
// module chunks = 0